import { motion } from 'framer-motion';
import { slideDownFromTop } from '../../../shared/helpers/animation';
import { Card } from 'primereact/card';
import { Divider } from 'primereact/divider';

const Resources = () => {

  const externalLink = (href:string, text:string) => {
    return <p>
        <a href={href}
          target="_blank"
          rel="noreferrer"
          className="text-cyan-800">
          <i className="pi pi-external-link m-3"/>
          {text}
        </a>
      </p>;
  }

  const iconCardLink = (href:string, iconUrl:string, text:string) => {
    return <Card className="flex-initial">
        <div className="">
          <a href={href}
              target="_blank"
              rel="noreferrer"
              className="flex flex-row gap-3 items-center">
            <img src={iconUrl} alt="link icon"/>
            <div className="text-cyan-800 text-xl p-1">
              {text}
            </div>
          </a>
        </div>
      </Card>;
  }

  return (
    <div className="flex w-full flex-col gap-y-4 p-8">
      <header className="mb-4 flex items-center gap-x-6">
        <motion.h1
          className="text-3xl font-bold"
          variants={slideDownFromTop}
          initial="hidden"
          animate="visible"
        >
          Resources
        </motion.h1>
      </header>

      <div className="flex flex-row flex-wrap gap-6">
        {
          iconCardLink("/Caloosha Caregiver Setup Guide.pdf",
            "/TherapistGuideIcon.png",
            "Caregiver Setup Guide"
          )
        }
        {
          iconCardLink("/Caloosha Child Use Guide R03.pdf",
            "/ChildComicIcon.png",
            "Child Use Guide"
          )
        }
      </div>
      
      <Divider/>

      {
        externalLink(
          "https://developingchild.harvard.edu/",
          "Center on the Developing Child at Harvard University"
        )
      }

      {
        externalLink(
          "https://www.nctsn.org/",
          "The National Child Traumatic Stress Network | (nctsn.org)"
        )
      }

      {
        externalLink(
          "https://sesameworkshop.org/topics/social-emotional-skills/childrens-feelings/",
          "Children's Feelings - Sesame Workshop"
        )
      }

      {
        externalLink(
          "https://childmind.org/",
          "Child Mind Institude"
        )
      }

      {
        externalLink(
          "https://childmind.org/education/thriving-kids/",
          "Thriving Kids Project - Child Mind Institute"
        )
      }

      {
        externalLink(
          "https://forms.gle/nxR56mEXmzyeUPQm7",
          "Caloosha - Workflow Integration Survey"
        )
      }

      {
        externalLink(
          "https://forms.gle/UujaMzTEqNEFJ7aR7",
          "Caloosha - Troubleshooting Report"
        )
      }

    </div>
  );
};

export default Resources;
